const state = {
  newnessEdit: null,
  newnessDelete: null
}

export default state